<div>
  <span>
    @if (title) {
      <p>{{title}}</p>
    }
  </span>
  <ng-content></ng-content>
</div>